module.exports = __webpack_public_path__ + "static/media/NTU_ML&DA.95110c77.JPG";